export const currentAccountBonusReducer = (state: string[] = []) => {
    return state;
};
